
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { MediaItemData } from "./types/mediaTypes";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import MediaItemForm from "./MediaItemForm";

interface EditMediaSheetProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  editingItem: MediaItemData | null;
}

const EditMediaSheet: React.FC<EditMediaSheetProps> = ({ 
  isOpen, 
  onOpenChange, 
  editingItem 
}) => {
  const { language } = useLanguage();

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto">
        <SheetHeader>
          <SheetTitle>
            {language === "en" ? "Edit Media Item" : "تعديل عنصر الوسائط"}
          </SheetTitle>
          <SheetDescription>
            {language === "en" 
              ? "Make changes to the media item here."
              : "قم بإجراء تغييرات على عنصر الوسائط هنا."
            }
          </SheetDescription>
        </SheetHeader>

        {editingItem && <MediaItemForm item={editingItem} onClose={() => onOpenChange(false)} />}
      </SheetContent>
    </Sheet>
  );
};

export default EditMediaSheet;
